import "core-js/modules/es6.array.map.js";
import "core-js/modules/es6.function.name.js";
import cloneDeep from 'lodash/cloneDeep';
/**
 *
 * @param {Object} payload payload
 * @param {Object} payload.question menu insight question
 * @param {Array} payload.products products currently available
 *
 * @returns {Array} array of 'dishes' based on products
 *
 */

function getNoCategoryDishes(_ref) {
  var question = _ref.question,
      products = _ref.products;

  if (!question || !Array.isArray(products)) {
    return [];
  }

  var dishes = products.map(function (p) {
    return {
      id: p.ref,
      ref: p.ref,
      title: p.name,
      // image: p.imageUrl, // This was in FC's design, but not sure we are implementing this atm
      subQuestions: getSubquestions(question, p)
    };
  });
  return dishes;
}
/**
 *
 * @param {Object} question menu insight question
 * @param {Object} product product
 *
 * @returns {Array} array of subQuestions for the product
 *
 */


function getSubquestions(question, product) {
  var subQuestions = [];
  var ratings = cloneDeep(question.ratings); // create subQuestion for each rating

  for (var i in ratings) {
    var rating = cloneDeep(ratings[i]);
    var reasonSections = cloneDeep(rating.reasonSections);

    for (var j in reasonSections) {
      var section = cloneDeep(reasonSections[j]);
      var sectionOptions = section.reasons.map(function (r) {
        return {
          id: r.id,
          label: r.text,
          val: r.id
        };
      });
      subQuestions.push({
        id: 'question' + question.id + 'product' + product.ref + 'rating' + i + 'reasonSection' + j,
        type: 'fib-select-option',
        showIf: section.showIf,
        required: false,
        // TODO - find out what sets this
        label: section.title,
        meta: {
          rating: rating,
          section: section
        },
        props: {
          center: true,
          multiple: true,
          options: sectionOptions
        }
      });
    }
  } // add comments box if applicable


  subQuestions.push({
    id: 'question' + question.id + 'product' + product.ref + 'comment',
    type: 'fib-comments',
    required: true,
    // TODO : find out if this needs setting and how to check if it is
    label: '',
    props: {
      rows: 6
    }
  });
  return subQuestions;
}

export default getNoCategoryDishes;